import React from "react";

// Source
import * as ModelPagination from "../model/Pagination";
import * as HelperSrc from "../HelperSrc";

export default class ControllerPagination {
    // Variable
    private props: ModelPagination.Iprops;

    private isRendered = React.useRef<boolean>(false);
    private limitPage = React.useRef(0);
    private count = React.useRef(0);
    private limit = React.useRef(0);
    private current = React.useRef(0);
    private groupPage = React.useRef(0);

    getGroupPage: number;
    setGroupPage: React.Dispatch<React.SetStateAction<number>>;

    getTotalGroupPage: number;
    setTotalGroupPage: React.Dispatch<React.SetStateAction<number>>;

    getStartPage: number;
    setStartPage: React.Dispatch<React.SetStateAction<number>>;

    getEndPage: number;
    setEndPage: React.Dispatch<React.SetStateAction<number>>;

    // Method
    constructor(props: ModelPagination.Iprops, isRendered: boolean) {
        this.props = props;

        this.isRendered.current = isRendered;
        this.limitPage.current = 5;
        this.count.current = props.response.count ? props.response.count : 0;
        this.limit.current = parseInt(props.response.limit ? props.response.limit : "");
        this.current.current = HelperSrc.urlVariable("page") ? parseInt(HelperSrc.urlVariable("page")) : 1;

        const [getGroupPage, setGroupPage] = React.useState<number>(this.groupPage.current);
        this.getGroupPage = getGroupPage;
        this.setGroupPage = setGroupPage;

        const [getTotalGroupPage, setTotalGroupPage] = React.useState<number>(0);
        this.getTotalGroupPage = getTotalGroupPage;
        this.setTotalGroupPage = setTotalGroupPage;

        const [getStartPage, setStartPage] = React.useState<number>(0);
        this.getStartPage = getStartPage;
        this.setStartPage = setStartPage;

        const [getEndPage, setEndPage] = React.useState<number>(0);
        this.getEndPage = getEndPage;
        this.setEndPage = setEndPage;
    }

    initializeHook = (): void => {
        React.useEffect(() => {
            const totalPage = Math.ceil(this.count.current / this.limit.current);

            this.setTotalGroupPage(Math.ceil(totalPage / this.limitPage.current));

            this.groupPage.current = Math.ceil(this.current.current / this.limitPage.current);
            this.setGroupPage(this.groupPage.current);

            this.setStartPage((this.groupPage.current - 1) * this.limitPage.current + 1);

            const maxPage = this.groupPage.current * this.limitPage.current;
            const endPage = totalPage > 0 ? totalPage : 1;

            this.setEndPage(endPage < maxPage ? endPage : maxPage);
        }, [this.limit.current, this.current.current, this.count.current]);
    };

    calculatePage = (): ModelPagination.IcalculatePage => {
        const total = this.calculateIndexLimit();
        const indexStart = (this.current.current - 1) * this.limit.current;
        const indexEnd = Math.min(indexStart + this.limit.current - 1, this.count.current - 1);

        return {
            total,
            indexStart,
            indexEnd,
            current: this.current.current
        };
    };

    clickGoToPage = (mode: string, index?: number, page = 1): void => {
        let resultIndex = 0;

        if (mode === "left") {
            resultIndex = this.current.current - page;
        } else if (mode === "center") {
            resultIndex = index ? index : 0;
        } else if (mode === "right") {
            resultIndex = this.current.current + page;
        }

        this.current.current = resultIndex;

        this.calculateIndexLimit();

        const currentUrl = new URL(window.location.href);
        const currentUrlSearchParameter = currentUrl.searchParams;

        currentUrlSearchParameter.set("page", this.current.current.toString());

        const newUrl = `${currentUrl.origin}${currentUrl.pathname}?${currentUrlSearchParameter.toString()}`;

        HelperSrc.routerHistoryPush(newUrl, {}, "", true);

        this.props.api();
    };

    clickPreviousGroup = (): void => {
        this.clickGoToPage("left", undefined, this.current.current - (this.groupPage.current - 1) * this.limitPage.current);
    };

    clickNextGroup = (): void => {
        this.clickGoToPage("right", undefined, this.groupPage.current * this.limitPage.current + 1 - this.current.current);
    };

    private calculateIndexLimit = (): number => {
        const total = Math.ceil(this.count.current / this.limit.current);

        if (this.current.current < 1) {
            this.current.current = 1;
        } else if (this.current.current > total && total > 0) {
            this.current.current = total;
        }

        return total > 0 ? total : 1;
    };
}
